/* eslint-disable no-unused-vars */
import React from 'react';
import ColumnInputFilter from '../../../../../components/table/ReactTableColumnFilter';
import SelectColumnFilter from '../../../../../components/table/SelectColumnFilter';
import Anchor from '../../../../../components/link/Anchor';
import {
  ADMIN_LEVEL_TYPE_LIST,
  ADMIN_LEVEL_TYPE_TEXT,
  ADMIN_STATUS_TYPE_LIST,
  ADMIN_STATUS_TYPE_TEXT,
} from '../../common/constants';

/**
 *  관리자 리스트 컬럼
 */
const accountAdminTableColumns = (onChangeFilterOption) => {
  return [
    {
      accessor: 'id',
      Header: '관리자 ID',
      disableFilters: true,
      disableSortBy: true,
      Cell: (row) => (
        <Anchor isUnderLine color="primary" href={`/account/admin/detail/${row.value}`} text={row.value} />
      ),
    },
    {
      accessor: 'email',
      Header: '이메일',
      disableSortBy: true,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'name',
      Header: '이름',
      disableSortBy: true,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'level',
      Header: '권한레벨',
      disableSortBy: true,
      Cell: (row) => ADMIN_LEVEL_TYPE_TEXT[row.value] || '_',
      Filter: ({ column }) => (
        <SelectColumnFilter list={ADMIN_LEVEL_TYPE_LIST} column={column} onChange={onChangeFilterOption} />
      ),
    },
    {
      accessor: 'status',
      Header: '관리자 상태',
      disableSortBy: true,
      Cell: (row) => ADMIN_STATUS_TYPE_TEXT[row.value] || '_',
      Filter: ({ column }) => (
        <SelectColumnFilter list={ADMIN_STATUS_TYPE_LIST} column={column} onChange={onChangeFilterOption} />
      ),
    },
  ];
};

export default accountAdminTableColumns;
